import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyRegistry } from './currency-registry';
import { DecimalPipe } from './decimal.pipe';

@Pipe({
	name: 'currencyFlexible'
})
export class CurrencyFlexiblePipe implements PipeTransform {

	static transform(value: any, currency: string, thousandSeparator: boolean = true): any {
		const meta = CurrencyRegistry.get(currency);
		const min = meta.full_precision;
		const max = Math.max(min, 4);
		const number = DecimalPipe.transform(value, min, max, thousandSeparator);
		return CurrencyRegistry.applyAffix(meta, number);
	}

	transform(value: any, currency: string, thousandSeparator: boolean = true): any {
		return CurrencyFlexiblePipe.transform(value, currency, thousandSeparator);
	}

}
